

<app-shared [type]="'bon-transfert'" [status]="'Transféré'"></app-shared>
